import { render, staticRenderFns } from "./OsPreventivaArmazem.vue?vue&type=template&id=07653414&"
import script from "./OsPreventivaArmazem.vue?vue&type=script&lang=js&"
export * from "./OsPreventivaArmazem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports